import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/dashboard')),
    },
    {
        key: 'dashboard.announcement-audit',
        path: `${APP_PREFIX_PATH}/dashboards/announcement-audit`,
        component: React.lazy(() => import('views/app-views/dashboards/announcement-audit')),
    },
    {
        key: 'dashboard.announcement-logs',
        path: `${APP_PREFIX_PATH}/dashboards/announcement-logs`,
        component: React.lazy(() => import('views/app-views/dashboards/announcement-audit/AnnouncementLogs')),
    },
    {
        key: 'dashboard.sector-dashboard',
        path: `${APP_PREFIX_PATH}/dashboards/sector-dashboard`,
        component: React.lazy(() => import('views/app-views/dashboards/sector-dashboard')),
    },
    {
        key: 'pages.user-list',
        path: `${APP_PREFIX_PATH}/pages/user-list`,
        component: React.lazy(() => import('views/app-views/pages/user-list')),
    },
    {
        key: 'themes',
        path: `${APP_PREFIX_PATH}/themes/*`,
        component: React.lazy(() => import('views/app-views/themes')),
    },
    {
        key: 'coupons',
        path: `${APP_PREFIX_PATH}/coupons/*`,
        component: React.lazy(() => import('views/app-views/coupons')),
    },
    {
        key: 'sectors',
        path: `${APP_PREFIX_PATH}/sectors`,
        component: React.lazy(() => import('views/app-views/sectors')),
    },
    {
        key: 'reports.login-failures',
        path: `${APP_PREFIX_PATH}/reports/login-failures`,
        component: React.lazy(() => import('views/app-views/reports/login-failures')),
    },
    {
        key: 'reports.7-day-free-trial',
        path: `${APP_PREFIX_PATH}/reports/7-day-free-trial`,
        component: React.lazy(() => import('views/app-views/reports/7-day-free-trial')),
    },
    {
        key: 'reports.upgrade-downgrade-rate',
        path: `${APP_PREFIX_PATH}/reports/upgrade-downgrade-rate`,
        component: React.lazy(() => import('views/app-views/reports/upgrade-downgrade-rate')),
    },
    {
        key: 'reports.user-active-event',
        path: `${APP_PREFIX_PATH}/reports/user-active-event`,
        component: React.lazy(() => import('views/app-views/reports/user-active-event')),
    },
    {
        key: 'reports.conversion',
        path: `${APP_PREFIX_PATH}/reports/conversion`,
        component: React.lazy(() => import('views/app-views/reports/conversion')),
    }
]
